import { toUtcDate } from 'ccs-ui-components';
import { UTCFILTER } from '../../control-plane/constants';

/**
 * @method isEmojiInput
 * @description verifies the enterd input is emoji or not
 * @param value input value
 * @returns true if emoji input, else false
 */
export const isEmojiInput = (value: string) => {
  const regex = /[\uD800-\uDBFF][\uDC00-\uDFFF]|\p{Emoji_Presentation}|\p{Emoji}\uFE0F/gu;
  if (regex.test(value)) {
    return true;
  }
  return false;
};

/**
 * @method Gets the from date or to date
 * @param fromDateOrToDate string from date or to date
 * @returns from date or to date
 */
export const getFromDateOrToDate = (fromDateOrToDate: string | null) => (fromDateOrToDate && fromDateOrToDate !== '' ? `${toUtcDate({ date: fromDateOrToDate }).replace(' ', 'T')}${UTCFILTER.UTC_FROM_TIMESTAMP_EXTENSION_STR}` : null);
